/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon16Light = forwardRef('ArrowDim1VIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.001 2.207 4.355 4.853a.5.5 0 0 1-.707-.707L6.44 1.353a1.5 1.5 0 0 1 2.121 0l2.792 2.792a.5.5 0 0 1-.708.707L8.001 2.206v11.587l2.645-2.645a.5.5 0 0 1 .708.707l-2.792 2.791a1.5 1.5 0 0 1-2.121 0l-2.793-2.793a.5.5 0 1 1 .707-.707l2.646 2.646V2.207Z" })));
});
